import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as amplitude from '@amplitude/unified';
import App from './App';
import './styles.css';

// Amplitude: initialized once per page load, client-side only.
// Autocapture covers page views + clicks; explicit track() calls (see
// src/lib/track.ts) handle custom signals like feature upvotes.
amplitude.initAll('760a0602948535d0778d34a77c79824b', {
  analytics: { autocapture: true },
});

const basename = import.meta.env.BASE_URL.replace(/\/$/, '');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
